import isPointInPolygon from "point-in-polygon"

export default class Zone {
    static isInBounds(zone, position, flag) {
        zone = zone || Zone.getPlaceholderZone()

        if(zone.points != undefined) {
            return isPointInPolygon([position.x, position.y], zone.points.map((point) => [point.x, point.y]))
        }

        return position != undefined
            && position.x >= zone.x
            && position.x < zone.x + zone.width
            && position.y >= zone.y
            && position.y < zone.y + zone.height
            // && position.z >= zone.z
            // && position.z < zone.z + 10
    }
    static isOutOfBounds(zone, position) {
        return this.isInBounds(zone, position) == false
    }
    static getPlaceholderZone() {
        return {
            "x": 0,
            "y": 0,
            "width": 7,
            "height": 7,
        }
    }
}
